// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  // AUTH
  auth: {
    signIn: `${ROOTS.AUTH}/sign-in`,
    verify: `${ROOTS.AUTH}/verify`,
    signUp: `${ROOTS.AUTH}/sign-up`,
    resetPassword: `${ROOTS.AUTH}/reset-password`,
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    place: {
      root: `${ROOTS.DASHBOARD}/places`,
      new: `${ROOTS.DASHBOARD}/places/new`,
      details: (id: string) => `${ROOTS.DASHBOARD}/places/${id}`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/places/${id}/edit`,
    },
    story: {
      root: `${ROOTS.DASHBOARD}/stories`,
      new: `${ROOTS.DASHBOARD}/stories/new`,
      details: (id: string) => `${ROOTS.DASHBOARD}/stories/${id}`,
      edit: (publicID: string) => `${ROOTS.DASHBOARD}/stories/${publicID}/edit`,
    },
    guide: {
      root: `${ROOTS.DASHBOARD}/guides`,
      new: `${ROOTS.DASHBOARD}/guides/new`,
      details: (guid: string) => `${ROOTS.DASHBOARD}/guides/${guid}`,
    },
    event: {
      root: `${ROOTS.DASHBOARD}/events`,
      new: `${ROOTS.DASHBOARD}/events/new`,
      discovery: `${ROOTS.DASHBOARD}/events/discovery`,
    },
    settings: {
      root: `${ROOTS.DASHBOARD}/settings`,
    },
    analytics: {
      root: `${ROOTS.DASHBOARD}/analytics`,
    },
    atlasAnalytics: {
      root: `${ROOTS.DASHBOARD}/atlas-analytics`,
    },
    placeBatches: {
      root: `${ROOTS.DASHBOARD}/place-batches`,
    },
  },
};
